/*
 * Copyright 2022 VMware, Inc.
 * SPDX-License-Identifier: EPL-2.0
 */
import { VIPConfig } from "../config";

export interface ContentSource extends ContentUnit {
    assets?: Array<ContentUnit>;
}

export interface ContentUnit {
    type: string;
    path: string;
}

export class ContentData {
    public tplKey: string;
    public tplValue: string;
    public srcPath: string;
    public assets: { [key: string]: any };

    /**
     * Parse pre-defined source object to initialize a content data object.
     * @param config Contains all required information of the application.
     * @param tplKey The key of the content template to get.
     */
    constructor(config: VIPConfig, tplKey: string) {
        const sourceObj = config.sourceBundle[tplKey];

        if (!sourceObj) {
            console.error(`Undefined source content key: ${tplKey}.`);
        }

        if (!sourceObj.path) {
            console.error(`The path of source content: ${tplKey} is undefined.`);
        }

        if (sourceObj && sourceObj.assets) {
            this.assets = {};
            sourceObj["assets"].forEach((unit: ContentUnit) => {
                if (unit.path && unit.path.lastIndexOf(".") > 0) {
                    // Figure out main key.
                    const path = (/\\|\//.test(unit.path.substring(0, 1)) ? unit.path.substring(1, unit.path.length) : unit.path).trim();
                    const mainKey = path.substring(0, path.lastIndexOf(".")).replace(/\/|\\/g, "-");

                    // Figure out file type.
                    const fileType = unit.type || path.substring(path.lastIndexOf(".") + 1, unit.path.length);
                    this.assets[`${mainKey}-${fileType}`] = { path: unit.path };
                } else {
                    console.error(`The path of asset: ${unit.path} is not supported.`);
                }
            });
        }
        this.tplKey = tplKey;
        this.srcPath = sourceObj.path;
    }

    /**
     * Extract the keys from a content data object.
     * @returns The key list.
     */
    public extractKeys() {
        let keys = [this.tplKey];
        if (this.assets) {
            keys = keys.concat(Object.keys(this.assets));
        }
        return keys;
    }
}
